import React from "react";
import Select from "react-select";

const defaultStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    minWidth: 180,
    borderRadius: 7,
    borderColor: state.isFocused ? "#487fff" : "#d1d5db",
    boxShadow: "none",
    "&:hover": {
      borderColor: state.isFocused ? "#487fff" : "#9ca3af",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 38,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 20,
  }),
};

/**
 * Common searchable single-select dropdown.
 * @param {Array<{value: string, label: string}>} options
 * @param {{value: string, label: string}|null} value
 * @param {(option) => void} onChange
 * @param {string} placeholder
 * @param {boolean} isLoading
 * @param {boolean} isClearable
 * @param {object} styles
 * @param {string} className
 */
const SearchableSelect = ({
  options = [],
  value = null,
  onChange,
  placeholder = "Select...",
  isLoading = false,
  isClearable = true,
  isDisabled = false,
  styles = {},
  className = "",
}) => {
  return (
    <Select
      className={`searchable-select ${className}`.trim()}
      classNamePrefix="searchable-select"
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isLoading={isLoading}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isSearchable
      styles={{ ...defaultStyles, ...styles }}
      noOptionsMessage={() => "No options found"}
    />
  );
};

export default SearchableSelect;
